import React, { useState } from 'react';
import './styles/DateRangePicker.css';

const DateRangePicker = ({ onChange }) => {
  const [startDate, setStartDate] = useState(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());
  const [activePreset, setActivePreset] = useState('30days');

  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  const handleStartDateChange = (e) => {
    const newStartDate = new Date(e.target.value);
    setStartDate(newStartDate);
    setActivePreset('custom');
    
    if (onChange) {
      onChange({ startDate: newStartDate, endDate });
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = new Date(e.target.value);
    setEndDate(newEndDate);
    setActivePreset('custom');
    
    if (onChange) {
      onChange({ startDate, endDate: newEndDate });
    }
  };

  const setPresetRange = (days, presetName) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    
    setStartDate(start);
    setEndDate(end);
    setActivePreset(presetName);
    
    if (onChange) {
      onChange({ startDate: start, endDate: end });
    }
  };

  return (
    <div className="date-range-picker">
      <div className="date-inputs">
        <div className="date-input-group">
          <label htmlFor="start-date">From</label>
          <input 
            id="start-date"
            type="date" 
            value={formatDate(startDate)}
            onChange={handleStartDateChange}
          />
        </div>
        <div className="date-input-group">
          <label htmlFor="end-date">To</label>
          <input 
            id="end-date"
            type="date"
            value={formatDate(endDate)}
            onChange={handleEndDateChange}
            min={formatDate(startDate)}
          />
        </div>
      </div>
      <div className="date-presets">
        <button 
          className={`date-preset-btn ${activePreset === '7days' ? 'active' : ''}`}
          onClick={() => setPresetRange(7, '7days')}
        >
          Last 7 Days
        </button>
        <button 
          className={`date-preset-btn ${activePreset === '30days' ? 'active' : ''}`}
          onClick={() => setPresetRange(30, '30days')}
        >
          Last 30 Days
        </button>
        <button 
          className={`date-preset-btn ${activePreset === '90days' ? 'active' : ''}`}
          onClick={() => setPresetRange(90, '90days')}
        >
          Last 90 Days
        </button>
        <button 
          className={`date-preset-btn ${activePreset === 'thisMonth' ? 'active' : ''}`}
          onClick={() => {
            const now = new Date();
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            
            setStartDate(firstDay);
            setEndDate(now);
            setActivePreset('thisMonth');
            
            if (onChange) {
              onChange({ startDate: firstDay, endDate: now });
            }
          }}
        >
          This Month
        </button>
      </div>
    </div>
  );
};

export default DateRangePicker;